// extracted by mini-css-extract-plugin
export default {"searchField":"SdkApplications_searchField__2mUXf","addApplicationButton":"SdkApplications_addApplicationButton__6BObm"};